import { mapGetters } from "vuex";
import confirmationPageMixin from "@/pages/confirmation/mixin";

export default {
  mixins: [confirmationPageMixin],
  computed: {
    ...mapGetters("app", ["isStripeEnabled"]),
  },
};
